class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('.sticky-atc');
    this.stickyAtc = this.querySelector('.add-to-cart-button--sticky');
    this.mainAtc = document.querySelector('.add-to-cart-button');
    this.productContainer = document.querySelector('.product-box');
    this.footer = document.querySelector('#shopify-section-other-footer');

    this.atcValue = this.stickyAtc.value
    this.loadingText = this.stickyAtc.dataset.loadingText

    // Ensure elements exist before proceeding
    if (!this.container || !this.mainAtc || !this.productContainer || !this.footer) return;

    const formId = this.stickyAtc.getAttribute('form')
    this.productForm = document.querySelector(`form#${formId}`)

    if(this.productForm) {
      this.productForm.addEventListener('submit', this.handleFormSubmit.bind(this))
    }

    // Bind and add scroll listener
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("cart:update", this.onCartUpdate.bind(this))
    
    // Run initial check
    this.handleScroll();
  }

  onCartUpdate(e) {
    this.stickyAtc.value = this.atcValue
  }

  handleFormSubmit(e) {
    this.stickyAtc.value = this.loadingText
  }

  handleScroll() {
    requestAnimationFrame(() => {
      const productRect = this.productContainer.getBoundingClientRect();
      const mainAtcRect = this.mainAtc.getBoundingClientRect();
      const footerRect = this.footer.getBoundingClientRect();

      const isProductAtTop = productRect.top <= 0;
      const isMainAtcVisible = mainAtcRect.top >= 0 && mainAtcRect.bottom <= window.innerHeight;
      const isFooterVisible = footerRect.top <= window.innerHeight;

      if (isProductAtTop && !isMainAtcVisible && !isFooterVisible) {
        this.container.classList.add('sticky-active');
      } else {
        this.container.classList.remove('sticky-active');
      }
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}

customElements.define("sticky-atc", StickyAtc);

document.addEventListener('DOMContentLoaded', function() {
  console.log('Module initialized!');
  
  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, arguments).then(async response => {
      if (response.url.includes('/cart/update') || response.url.includes('/cart/add') || response.url.includes('/cart/change')) {
        // Fetch latest cart data
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        // Store cart data in session storage for other components
        sessionStorage.setItem('cartData', JSON.stringify(cartData));
        
        // Calculate cart total
        const cartTotal = cartData.items.reduce((sum, item) => sum + item.final_price, 0);

        // Trigger cart:update event with cart data
        window.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            cartData,
            cartTotal
          }
        }));
      }
      return response;
    });
  };

  // Intercept XMLHttpRequest requests
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    
    if (arguments[1].includes('/cart/update') || arguments[1].includes('/cart/add') || arguments[1].includes('/cart/change')) {
      this.addEventListener('load', async function() {
        
        // Fetch latest cart data
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        // Store cart data in session storage
        sessionStorage.setItem('cartData', JSON.stringify(cartData));
        
        // Calculate cart total
        const cartTotal = cartData.items.reduce((sum, item) => sum + item.final_price, 0);
        
        // Trigger cart:update event with cart data
        window.dispatchEvent(new CustomEvent('cart:update', {
          detail: {
            cartData,
            cartTotal
          }
        }));
      });
    }
    originalXHROpen.apply(this, arguments);
  };
});
